import type {z} from "zod";

import {CheckLeadSimilarityBody} from "@project/sdk/sales/zod";

export const checkLeadSimilaritySearchSchema = CheckLeadSimilarityBody;
export type CheckLeadSimilaritySearchInput = z.input<typeof checkLeadSimilaritySearchSchema>;
export type CheckLeadSimilaritySearch = z.output<typeof checkLeadSimilaritySearchSchema>;
